export const status_fields = {
    changeStatus: {
        loadingStr:'applyStatusModalLoading',
        url:'/stock_status_apply/create',
        showModalStr:'showApplyStatusModal',
        successStr:'修改成功',
    },
    revocationStatus: {
        loadingStr:'revocationApplyModalLoading',
        url:'/stock_status_apply/delete',
        showModalStr:'showRevocationApplyModal',
        successStr:'撤销成功',
    }
}

export const conctract_type = [
    {
        title: '支出类合同：',
        content: '我方作为采买，接受货物或劳务服务，后续需关联付款来完成交易活动。'
    },
    {
        title: '收入类合同：',
        content: '我方作为销售方，接受货物或劳务服务，后续需关联收款来完成交易活动。'
    },
    {
        title: '有收有支合同：',
        content: '我方作为采买方，同时也作为销售方。后续需关联付款和收款来完成交易活动。'
    },
    {
        title: '无收无支合同：',
        content: '合同中不涉及经济活动，即不需要后续收款或付款。'
    }
]

export const conctract_t_t = [
    // {
    //     title: '框架协议：',
    //     content: '仅针对交易达成意向并针对主要合作内容订立合同，并不包含交易结算细节等内容，即框架协议不可直接付款，若需付款，则需提供订单、结算单等证明文件，在系统中新建合同并关联框架协议才可付款。',
    //     content_1: '（无需填写合同预估金额）',
    // },
    {
        only: true,
        content: '若为平台标准协议文本，请在 [合同类别] 处选择非存货类合同。',
       
    },
]

export const conctract_attribute = [
    // {
    //     title: '框架协议：',
    //     content: '仅针对交易达成意向并针对主要合作内容订立合同，并不包含交易结算细节等内容，即框架协议不可直接付款，若需付款，则需提供订单、结算单等证明文件，在系统中新建合同并关联框架协议才可付款。',
    //     content_1: '（无需填写合同预估金额）',
    // },
    {
        title: '开口合同：',
        content: '合同中存在结算条款，但具体价格无法明确，开口合同后续可直接付款。',
        content_1: '（需填写合同预估金额）',
    },
    {
        title: '闭口合同：',
        content: '即存在结算条款，且价格明确，并作为后续付款的依据。',
    }
]


export const contract_i_e_types = [
    {
        key: 'expense',
        label: '支出类合同',
        value: 'expense'
    },
    {
        key: 'income',
        label: '收入类合同',
        value: 'income'
    },
    {
        key: 'expense_income',
        label: '有收有支合同',
        value: 'expense_income'
    },
    {
        key: 'costless',
        label: '无收无支合同',
        value: 'costless'
    }
]

export const contract_i_e_types_hash = contract_i_e_types.reduce((t, i) => {
    t[i.value] = i.label
    return t
}, {})

export const contract_nature_list = [
    // {
    //     key: 'frame',
    //     label: '框架协议',
    //     value: 'frame'
    // },
    {
        key: 'open',
        label: '开口合同',
        value: 'open'
    },
    {
        key: 'close',
        label: '闭口合同',
        value: 'close'
    }
]

export const contract_nature_list_hash = contract_nature_list.reduce((total, item) => {
    total[item.key] = item.label
    return total
}, {})


export const status_list = [
    {
      label: '正常品',
      value: 'normal'  
    },
    {
      label: '清库存',
      value: 'clear_inventory'  
    },
    {
      label: '呆滞品',
      value: 'slow_moving'  
    },
    {
      label: '报废品',
      value: 'scraped'  
    }
  ]

export const status_hash = status_list.reduce((t, i) => {
    t[i.value] = i
    return t
}, {})